export const responsive = {
	breakpoints: {
		xs: '1px',
		sm: '576px',
		md: '808px',
		lg: '992px',
		xl: '1200px'
	}
}
